import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Reusable loading placeholder for the admin management pages that share the
// same shape: a title (+ optional subtitle), an optional row of tabs, then a
// bordered table (header row + data rows). Tune per page via props.
export default function AdminTableSkeleton({
    isDarkMode,
    maxW = "max-w-6xl",
    withSubtitle = false,
    tabs = 0,
    rows = 8,
    cols = 5,
}) {
    const baseColor = isDarkMode ? "#334155" : "#e2e8f0";
    const highlightColor = isDarkMode ? "#475569" : "#f1f5f9";
    const cardBorder = isDarkMode ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200";

    return (
        <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
            <div className={`min-h-screen ${isDarkMode ? "bg-surface" : "bg-surface"}`}>
                <div className={`${maxW} mx-auto px-4 py-8`}>
                    <Skeleton width={240} height={30} className="mb-2" />
                    {withSubtitle && <Skeleton width={340} height={16} className="mb-6" />}
                    {!withSubtitle && <div className="mb-6" />}

                    {tabs > 0 && (
                        <div className="flex flex-wrap gap-2 mb-6">
                            {Array.from({ length: tabs }).map((_, i) => (
                                <Skeleton key={i} width={120} height={38} borderRadius={10} />
                            ))}
                        </div>
                    )}

                    <div className={`rounded-2xl border shadow-sm overflow-hidden ${cardBorder}`}>
                        {/* Header row */}
                        <div className={`px-4 py-3 ${isDarkMode ? "bg-slate-700/40" : "bg-slate-50"}`}>
                            <div className="grid gap-4" style={{ gridTemplateColumns: `repeat(${cols}, 1fr)` }}>
                                {Array.from({ length: cols }).map((_, c) => (
                                    <Skeleton key={c} height={14} />
                                ))}
                            </div>
                        </div>
                        {/* Data rows */}
                        <div className={`divide-y ${isDarkMode ? "divide-slate-700" : "divide-slate-100"}`}>
                            {Array.from({ length: rows }).map((_, r) => (
                                <div key={r} className="px-4 py-3.5">
                                    <div className="grid gap-4 items-center" style={{ gridTemplateColumns: `repeat(${cols}, 1fr)` }}>
                                        {Array.from({ length: cols }).map((_, c) => (
                                            <Skeleton key={c} height={14} width={c === 0 ? "80%" : "60%"} />
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </SkeletonTheme>
    );
}
